module.exports = "../../app/cells/components/modals/account_limit_free_modal_cell.rb";